import {get, map, merge, pipe} from '@logistics-frontend/utils'
import {SuggestAction} from '@yandex-delivery/api/model/suggest'

import type {AddressSuggestResponse, AddressSuggestResponsePromise, Order as FormValues} from '../../types'
import {fromPinDropToPointAddress, getCoordinates} from '../../utils'
import {suggestService} from './fetch-address-suggest'

const {fetchAddressSuggest} = suggestService
export async function fetchRouteFromQuery(from: string, to?: string) {
  const promises: AddressSuggestResponsePromise[] = []
  const sourcePoint = getCoordinates(from)
  const destinationPoint = getCoordinates(to)

  if (sourcePoint) {
    promises.push(
      fetchAddressSuggest({
        point: sourcePoint,
        type: 'a',
        location: sourcePoint,
        action: SuggestAction.PIN_DROP,
      }),
    )

    if (destinationPoint) {
      promises.push(
        fetchAddressSuggest({
          point: destinationPoint,
          type: 'b',
          location: sourcePoint,
          action: SuggestAction.PIN_DROP,
        }),
      )
    }
  }

  const [source, destination] = await Promise.allSettled(promises) //
    // не хочу заморачиваться с разными типами PromiseSettledResult, просто скастуем в возвращаемый тип саджеста
    .then(map(get('value')) as unknown as () => AddressSuggestResponse[])
    .then(map(fromPinDropToPointAddress))

  const routeFromQuery = {
    sourcePoint: {
      address: source,
    },
    destinationPoints: [{address: destination}],
  }

  return function _withRouteFromQuery(defaultValues: FormValues): FormValues {
    return pipe(routeFromQuery, merge(defaultValues))
  }
}
